<template>
  <div class="home">
    
    <DialogConfirmDriver/>
    <Parte/>
  </div>
</template>

<script>
// @ is an alias to /src
import Parte from '@/components/Parte.vue'
import DialogConfirmDriver from '@/components/DialogConfirmDriver.vue'

export default {
  name: 'ParteView',
  components: {
    Parte,
    DialogConfirmDriver
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
